var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"identicon",staticClass:"avatar identicon",class:[_vm.sizeClass, _vm.identiconBackgroundClass]},[_vm._v("\n  "+_vm._s(_vm.identiconTitle)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }